export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg font-heading">
                密
              </span>
              <span className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">
                密桃视频
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed max-w-[280px]">
              高清影视聚合观影平台，汇聚香蕉视频、糖豆视频、小蓝视频、蓝莓视频等热门平台资源，免费在线观看全集电影电视剧，每日更新不缓冲。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-background-50 mb-4">快速导航</h3>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '特色优势', href: '#features' },
                { label: '平台简介', href: '#about' },
                { label: '焦点专题', href: '#carousel' },
                { label: '最新动态', href: '#updates' },
                { label: '专题索引', href: '#index' },
              ].map((item, i) => (
                <a
                  key={i}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector(item.href);
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-background-50 mb-4">内容分区</h3>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '精选剧场', href: '#media' },
                { label: '热度榜单', href: '#ranking' },
                { label: '精选推荐', href: '#cards' },
                { label: '常见问题', href: '#faq' },
                { label: '联系我们', href: '#contact' },
              ].map((item, i) => (
                <a
                  key={i}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector(item.href);
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-400">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 密桃视频 - 高清影视聚合观影平台。本站内容仅供学习交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-400 whitespace-nowrap">香蕉视频</span>
            <span className="w-px h-3 bg-foreground-700/30"></span>
            <span className="text-xs text-foreground-400 whitespace-nowrap">糖豆视频</span>
            <span className="w-px h-3 bg-foreground-700/30"></span>
            <span className="text-xs text-foreground-400 whitespace-nowrap">小蓝视频</span>
            <span className="w-px h-3 bg-foreground-700/30"></span>
            <span className="text-xs text-foreground-400 whitespace-nowrap">蓝莓视频</span>
          </div>
        </div>
      </div>
    </footer>
  );
}